import { FormElement, FormInputElement } from '../../render-form';

export const isFormInputElement = (element: FormElement): element is FormInputElement => typeof element.name === 'string';
